import { useNavigate } from 'react-router-dom';
import { HubTopNav } from '@prosolve/common-components-ui'
import useIsMobileView from '../hooks/useIsMobileView';
import useMe from '../hooks/useMe';
import { appRootPath } from '../utils';

// The shared hub top bar (ProSolve logo, profile menu, logout through the root API) rendered by
// every private go app, with the same props the other hub portals pass. It is position: fixed and
// 39px tall, so each app offsets its own content by that height. Needs the private-route loader
// data (useMe) to show the signed-in user. appLogo is HubTopNav's slot for app-specific content
// (title, tabs) rendered right after the ProSolve logo; MobileDrawerNav is the component HubTopNav
// renders inside its hamburger drawer on mobile (it receives setIsDrawerOpen to close the drawer).
export default ({ appLogo, MobileDrawerNav }) => {
  const isMobileView = useIsMobileView();
  const navigate = useNavigate();
  const me = useMe();

  return (
    <HubTopNav
      isMobileView={isMobileView}
      isHideTheme={true}
      isDark={true}
      MobileDrawerNav={MobileDrawerNav}
      navigate={navigate}
      appRootPath={`${appRootPath}/`}
      appLogo={appLogo}
      me={me}
    />
  )
}
